/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayerOverridesViewModelResult } from '../../models/player-overrides-view-model-result';

export interface ApiPlayerOverridesIdGet$Any$Params {
  id: number;
}

export function apiPlayerOverridesIdGet$Any(http: HttpClient, rootUrl: string, params: ApiPlayerOverridesIdGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerOverridesIdGet$Any.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerOverridesViewModelResult>;
    })
  );
}

apiPlayerOverridesIdGet$Any.PATH = '/api/player/overrides/{id}';
